import { render } from "./BelizeonTopHeader.vue?vue&type=template&id=e49f8322"
import script from "./BelizeonTopHeader.vue?vue&type=script&lang=js"
export * from "./BelizeonTopHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__